export default __webpack_public_path__ + "fa0bb4d056f6e3288194e4b8c60cd519.svg";